import Card from "react-bootstrap/Card";
import CaseList from "../CaseList/CaseList";
import { HelpModal as CaseListModal } from "../CaseList/CaseListHelp";
import Graph from "../GraphView/Graph";
import { HelpModal as GraphModal } from "../GraphView/GraphHelp";
import Nav from "react-bootstrap/Nav";
import { HelpModal as OverlapModal } from "../OverlapView/OverlapHelp";
import Overlaps from "../OverlapView/Overlaps";
import PatientSummary from "./PatientSummary";
import React from "react";
import Survey from "../Survey/Survey";
import Tree from "../TreeView/Tree";
import { HelpModal as TreeModal } from "../TreeView/TreeHelp";
import TreeTable from "../TreeTable/TreeTable";
import { HelpModal as TreeTableModal } from "../TreeTable/TreeTableHelp";
import { connect } from "react-redux";
import { patientActions } from "../../actions";

class OverlapCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { view: "overlaps" };
  }

  reapplyGeneticConstraints = () => {
    if (!this.props.overlapConstraint) return;
    this.props.constraintLoadingReset?.();
    this.props.constrainByOverlap?.(false);
    this.props.constrainOverlap?.([]);
    this.props.constrainTree?.([]);
    this.props.constrainGraph?.([], false);
    this.props.highlightPhylos?.([], false);
    // Toggle back on so the active view recomputes constraints with fresh data
    this.props.constrainByOverlap?.(true);
  };

  handleClick = (view_state) => {
    return () => {
      if (view_state === this.state.view) {
        return;
      }
      if (view_state === "graph" || view_state === "overlaps") {
        this.reapplyGeneticConstraints();
      }
      this.setState({
        ...this.state,
        view: view_state,
      });
      this.props.setOverlapView?.(view_state);
    };
  };

  componentDidMount() {
    this.props.setOverlapView?.(this.state.view);
  }

  render() {
    const isLinked = this.props.overlapConstraint;
    return (
      <Card className="border border-primary">
        <Card.Header
          className={`bg-light text-dark border-primary${
            isLinked ? " linked-card-header" : ""
          }`}
        >
          <Nav variant="tabs" defaultActiveKey="#1">
            <Nav.Item>
              <Nav.Link
                href="#1"
                onClick={this.handleClick("overlaps")}
                className="text-dark"
              >
                Overlap Viewer
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href="#3"
                onClick={this.handleClick("graph")}
                className="text-dark"
              >
                {" "}
                Overlap Graph
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href="#2"
                onClick={this.handleClick("table")}
                className="text-dark"
              >
                Case List
              </Nav.Link>
            </Nav.Item>



            <div className="ms-auto"></div>
            {this.state.view === "overlaps" ? (
              <Nav.Item style={{ marginRight: "15px" }}>
                <OverlapModal className="modal" />
              </Nav.Item>
            ) : this.state.view === "graph" ? (
              <Nav.Item style={{ marginRight: "15px" }}>
                <GraphModal className="modal" />
              </Nav.Item>
            ) : (
              <Nav.Item style={{ marginRight: "15px" }}>
                <CaseListModal className="modal" />
              </Nav.Item>
            )}
          </Nav>
        </Card.Header>
        <Card.Body
          className="overlap-card-body"
          style={{ 
            maxHeight: "calc(100vh - 270px)", 
            overflowY: "auto",
            overflowX: "auto" }}
        >
          {this.state.view === "overlaps" ? (
            <Overlaps micro_id={this.props.micro_id} />
          ) : (
            <>
              {this.state.view === "graph" ? (
                <Graph micro_id={this.props.micro_id} />
          ) : (
                <CaseList micro_id={this.props.micro_id} />
              )}
            </>
          )}
        </Card.Body>
      </Card>
    );
  }
}

class TableCard extends React.Component {
  render() {
    return (
      <Card className="border border-primary">
        <Card.Header className="bg-light text-dark border-primary">
          <Nav variant="tabs" defaultActiveKey="#1">
            <Nav.Item>
              <Nav.Link
                href="#1"
                // onClick={this.handleClick("table")}
                className="text-dark"
              >
                Case List
              </Nav.Link>
            </Nav.Item>
            <div className="ms-auto"></div>
            <Nav.Item style={{ marginRight: "15px" }}>
              <CaseListModal className="modal" />
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Card.Body
          className="overlap-card-body"
          style={{ 
            maxHeight: "calc(100vh - 270px)", 
            overflowY: "auto",
            overflowX: "auto" }}
        >
          <CaseList micro_id={this.props.micro_id} />
        </Card.Body>
      </Card>
    );
  }
}

class TreeCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { view: "tree" };
  }

  handleClick = (view_state) => {
    return () => {
      this.setState({
        ...this.state,
        view: view_state,
      });
    };
  };
  render() {
    const isLinked = this.props.overlapConstraint;
    return (
      <Card className="border border-primary">
        <Card.Header
          className={`bg-light text-dark border-primary${
            isLinked ? " linked-card-header" : ""
          }`}
        >
          <Nav variant="tabs" defaultActiveKey="#1">
            <Nav.Item>
              <Nav.Link
                href="#1"
                onClick={this.handleClick("tree")}
                className="text-dark"
              >
                Tree View
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href="#2"
                onClick={this.handleClick("table")}
                className="text-dark"
              >
                {" "}
                Tree Table
              </Nav.Link>
            </Nav.Item>{" "}
            {/* this div will take up space between nav items and modal */}
            <div className="ms-auto"></div>
            {this.state.view === "tree" ? (
              <Nav.Item style={{ marginRight: "15px" }}>
                <TreeModal className="modal" />
              </Nav.Item>
            ) : (
              <>
                {" "}
                <Nav.Item style={{ marginRight: "15px" }}>
                  <TreeTableModal className="modal" />
                </Nav.Item>
              </>
            )}
          </Nav>
        </Card.Header>

        <Card.Body
          className="tree-card-body"
          style={{ 
            maxHeight: "calc(100vh - 270px)", 
            overflowY: "auto",
            overflowX: "hidden" }}
        >
          {this.state.view === "tree" ? (
            <Tree micro_id={this.props.micro_id} />
          ) : (
            <>
              <TreeTable micro_id={this.props.micro_id} />
            </>
          )}
        </Card.Body>
      </Card>
    );
  }
}

class TreeTableCard extends React.Component {
  render() {
    return (
      <Card className="border border-primary">
        <Card.Header className="bg-light text-dark border-primary">
          Tree Table
        </Card.Header>
        <Card.Body className="tree-card-body">
          <TreeTable micro_id={this.props.micro_id} />
        </Card.Body>
      </Card>
    );
  }
}

class SurveyButtonCard extends React.Component {
  render() {
    return <Survey />;
  }
}
class GraphCard extends React.Component {
  render() {
    return (
      <Card>
        <Card.Header>Infection Graph</Card.Header>
        <Card.Body className="overlap-card-body">
          <Graph micro_id={this.props.micro_id} />
        </Card.Body>
      </Card>
    );
  }
}

const mapStateToLinkProps = (state) => ({
  overlapConstraint: state.patient.tree.overlap_constraint,
});

const ConnectedOverlapCard = connect(mapStateToLinkProps, {
  constrainByOverlap: patientActions.constrainByOverlap,
  constrainGraph: patientActions.constrainGraph,
  constrainOverlap: patientActions.constrainOverlap,
  constrainTree: patientActions.constrainTree,
  constraintLoadingReset: patientActions.constraintLoadingReset,
  highlightPhylos: patientActions.highlightPhylos,
  setOverlapView: patientActions.setOverlapView,
})(OverlapCard);
const ConnectedTreeCard = connect(mapStateToLinkProps)(TreeCard);

export {
  ConnectedOverlapCard as OverlapCard,
  TableCard,
  ConnectedTreeCard as TreeCard,
  SurveyButtonCard,
  GraphCard,
};
